import { render, staticRenderFns } from "./BenefitDecisionPanel.vue?vue&type=template&id=12a47908&scoped=true"
import script from "./BenefitDecisionPanel.vue?vue&type=script&lang=js"
export * from "./BenefitDecisionPanel.vue?vue&type=script&lang=js"
import style0 from "./BenefitDecisionPanel.vue?vue&type=style&index=0&id=12a47908&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a47908",
  null
  
)

export default component.exports